export default "__VITE_ASSET__Djwni$w5__"